import React from 'react';
import CloseAccount from './CloseAccount';
import {RedirectWithParams} from 'epic-diesel-common';
import {useSelector} from 'react-redux';
import {selectAffiliate, selectEnableMigration} from '../../selectors';
import {Affiliate} from '../../../shared/types';
import {canMigrate} from '../../../shared/utils/ValidationUtils';
import {RootState} from '../..';

const CloseAccountView = () => {
    const affiliate = useSelector<RootState, Affiliate>(selectAffiliate);
    const enableV2Migration = useSelector<RootState, boolean>(selectEnableMigration);

    if (!enableV2Migration || !canMigrate(affiliate)) {
        return <RedirectWithParams to="overview" ignoreSearch />;
    }

    return <CloseAccount affiliate={affiliate} />;
};

export default CloseAccountView;
